module.exports = __webpack_public_path__ + "media/images/review/ico-crown-1-c7050bd3e74971bbb59905a6cc81e43e.svg";